@if (chapterText) {
  {{ chapterText }}
  <br>
  }
  @if (designation) {
    <small>
      {{ designation }}
    </small>
    <br>
    }
    @if (dedicationType) {
      <span>
        <small>
          {{ getDedicationText() }}
        </small>
      </span>
    }